<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width: 100% !important;">
                <div class="page-name">{{pageTitle}}</div>
                <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div :class="alertClass" id="success-alert">
                    <strong> {{alertMessage}} </strong>
                </div>
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <!-- Part No -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Part No:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{partName}}</span>
                            </div>
                        </div>

                        <!-- Ship Qty -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Ship Qty:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="shipQty" placeholder="Enter Ship Qty" v-model="shipQty">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{shipQtyError}}</span>
                            </div>
                        </div>

                        <!-- Used Qty -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Used Qty:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{usedQty}}</span>
                            </div>
                        </div>
                        
                        <!-- Back Order Qty -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Backorder Qty:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <span class="form-control">{{backOrderQty}}</span>
                            </div>
                        </div>
                        
                        <!-- Invoice No -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Inovice No:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="invoiceNo" placeholder="Enter Invoice No" v-model="invoiceNo">
                                <div class="requiredstar">*</div>
                                <span class="text-danger">{{invoiceNoError}}</span>
                            </div>
                        </div>
                        
                        <!-- Invoice Date -->
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Inovice Date:</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <input class="form-control" id="invoiceDate" placeholder="MM/DD/YYYY" v-model="invoiceDate">
                                <!-- <div class="requiredstar">*</div>
                                <span class="text-danger">{{invoiceDateError}}</span> -->
                            </div>
                        </div>
                    </div>

                    <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="button-demo">
                        <input id="addBenifitBtn" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="updatePartDepletionHistoryData()">
                        <input id="CancelBenifit" :disabled="disableButtons.cancel" type="submit" :value="buttonNames.cancel" class="btn btn-primary" v-on:click.prevent="buttonBack">
                    </div>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    import axios from 'axios'

    var moment = require('moment-timezone');

    export default {
        name: 'AddUpdateParts',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
        },
        data() {
            return {
                pageTitle : "Update Part Depletion History",
                partDepletionId: 0,
                partId: 0,
                customerId: 0,
                excedeCustomerId: 0,
                inventoryId: 0,
                actualBackQty: 0,
                poNumber: "",

                partName: "",
                shipQty: "",
                shipQtyError: "",
                
                usedQty: "",
                backOrderQty: 0,

                invoiceNo: "",
                invoiceNoError: "",
                
                invoiceDate: "",
                invoiceDateError: "",

                buttonNames : {
                    save : 'Update',
                    cancel : 'Cancel'
                },
                disableButtons : {
                    save : false,
                    cancel : false
                },
                alertClass : '',
                alertMessage : '',
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "dashboard");
        },
        watch: {
            shipQty: function(shipQty) {
                self.backOrderQty = self.usedQty - shipQty;
                self.shipQtyError = "";

                if (!self.allnumeric(self.shipQty)) {
                    self.shipQtyError = "Only Number Allowed";
                    self.backOrderQty = 0;
                }
                if(shipQty > self.usedQty) {
                    self.shipQtyError = "Ship Qty is not greater than Used Qty";
                    self.backOrderQty = 0;
                }
                if(self.actualBackQty != 0 && self.actualBackQty < shipQty) {
                    shipQty = self.actualBackQty;
                    self.backOrderQty = 0;
                }
                if(self.actualBackQty == self.shipQty) {
                    self.backOrderQty = 0;
                }
                if(shipQty == 0) {
                    self.backOrderQty = self.usedQty;
                }
            }
        },
        mounted: function () {
            $("#alertError").hide();
            self.getAllPermissions();
            if (typeof(self.$route.params.id) != "undefined" && self.$route.params.id != "" && self.$route.params.id != 0) {
                self.partDepletionId = self.$route.params.id;
                self.getPartDepletionHistoryData(self.$route.params.id);
            }
        },
        beforeDestroy() {
        },
        methods: {
            buttonBack: function () {
                self.$router.push('/dashboard');
            },
            getPartDepletionHistoryData: function(partDepletionId) {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                    params:{
                        part_depletion_id: partDepletionId,
                    }
                };
                var url = "/partdepletion/history/get";
                HTTP.get(url, config)
                    .then(function (response) {
                        if (response.status == 200) {
                            self.partName = response.data.content.partName;
                            self.partId = response.data.content.partId;
                            self.customerId = response.data.content.customerId;
                            self.usedQty = response.data.content.qty;
                            self.invoiceNo = response.data.content.invoiceNo;
                            self.invoiceDate = response.data.content.invoiceDate;
                            self.poNumber = response.data.content.poNumber;
                            self.excedeCustomerId = response.data.content.excedeCustomerId;
                            self.inventoryId = response.data.content.inventoryId;
                            self.actualBackQty = response.data.content.backOrderQty;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            allnumeric : function (inputtxt) {
                var numbers = /^\d+$/;;
                if(numbers.test(inputtxt)) {
                    return true;
                } else {
                    return false;
                }
            },
            validateForm: function() {
                var error = false;
                self.invoiceNoError = "";
                self.invoiceDateError = "";
                self.shipQtyError = "";

                // if (self.shipQty <= 0) {
                if (self.shipQty < 0) {
                    self.shipQtyError = "Please enter valid Qty";
                    error = true;
                } else if (!self.allnumeric(self.shipQty)) {
                    self.shipQtyError = "Only Number Allowed";
                    error = true;
                }
                if(self.shipQty > self.usedQty) {
                    self.shipQtyError = "Ship Qty is not greater than Used Qty";
                    error = true;
                }
                if(!self.invoiceNo) {
                    self.invoiceNoError = "Please Enter Invoice No";
                    error = true;
                }
                return error;
            },
            updatePartDepletionHistoryData: function() {
                var error = self.validateForm();
                /* if(self.actualBackQty != 0 && self.actualBackQty < self.shipQty) {
                    self.shipQty = self.actualBackQty;
                    self.backOrderQty = 0;
                }
                if(self.actualBackQty == self.shipQty) {
                    self.backOrderQty = 0;
                } */
                if(!error) {
                    self.buttonNames.save = "Updating ...";
                    self.disableButtons.save = true;
                    var config = {
                        headers: {
                            Authorization:localStorage.getItem("access_token")
                        },
                    };
                    var fields = {
                        partDepletionId: self.partDepletionId,
                        qty: self.shipQty,
                        backOrderQty: self.backOrderQty,
                        partId: self.partId,
                        partName: self.partName,
                        customerId: self.customerId,
                        invoiceNo: self.invoiceNo,
                        invoiceDate: self.invoiceDate,
                        poNumber: self.poNumber,
                        excedeCustomerId: self.excedeCustomerId,
                        inventoryId: self.inventoryId,
                    };
                    HTTP.post("/partdepltionhistorydata/update", fields, config)
                        .then(function (response) {
                            self.buttonNames.save = "Update";
                            self.disableButtons.save = false;
                            if (response.status == 200) {
                                self.buttonBack();
                                self.showSAlert('Part Depletion Data Update successfully', 'success', false);
                            }
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.buttonNames.save = "Update";
                            self.disableButtons.save = false;
                            self.catchHandler(error);
                        })
                }
            },
        }
    }
</script>

<style>
  .field-icon {
    float: right;
    margin-right: 8px;
    margin-top: -23px;
    position: relative;
    z-index: 2;
    cursor:pointer;
  }

  .container{
    padding-top:50px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/Parts/UpdatePartDepletionHistory.vue